"use client";

import { FloatingArrow } from "@floating-ui/react";
import React from "react";

import {
  POPOVER_ARROW_HEIGHT,
  POPOVER_ARROW_WIDTH,
  POPOVER_ARROW_TIP_RADIUS,
} from "./consts";
import { usePopoverContext } from "./PopoverContext";

export const PopoverArrow: React.FC = () => {
  const { arrowRef, middlewareData, floatingContext } = usePopoverContext();

  const arrowStyle = {
    ...(middlewareData.arrow?.x ? { left: middlewareData.arrow?.x } : {}),
    ...(middlewareData.arrow?.y ? { top: middlewareData.arrow?.y } : {}),
  };

  return (
    <FloatingArrow
      ref={arrowRef}
      context={floatingContext}
      className="fs-popover__arrow"
      width={POPOVER_ARROW_WIDTH}
      height={POPOVER_ARROW_HEIGHT}
      tipRadius={POPOVER_ARROW_TIP_RADIUS}
      style={arrowStyle}
    />
  );
};
